import { useEffect, useState } from "react";
import { ParallaxProvider, Parallax } from "react-scroll-parallax";
import { useInView } from "react-intersection-observer";
import Rank1NMV from "../../images/Rank1NMV.png";
import Rank2NMV from "../../images/Rank2NMV.png";
import Rank3NMV from "../../images/Rank3NMV.png";
import Rank4NMV from "../../images/Rank4NMV.png";
import Rank5NMV from "../../images/Rank5NMV.png";
import ProductCard from "./ProductCard";

const RowBestNMV = () => {
  const [refFact1, refFact1InView] = useInView();
  const [refFact1isVisible, setrefFact1IsVisible] = useState(false);
  useEffect(() => {
    if (refFact1InView && !refFact1isVisible) {
      setrefFact1IsVisible(true);
    } else if (!refFact1InView && refFact1isVisible) {
      setrefFact1IsVisible(false);
    }
  }, [refFact1isVisible, refFact1InView]);

  return (
    <div className="color-dk-r">
      <div className="row m-0 flex-row text-center">
        <div className="stickyRowHeaders2 col-lg-4 col-12 d-flex align-items-center justify-content-center">
          <div className="d-lg-none d-inline">
            <div>Best Selling Products</div>
            <div>(NMV-wise)</div>
          </div>
          <div className="d-none d-lg-block">
            <ParallaxProvider>
              <Parallax
                translateY={[-200, 100]}
                opacity={[1, 0.8]}
                easing="easeOut"
                scale={[0.8, 1]}
              >
                <div>Best Selling Products</div>
                <div>(NMV-wise)</div>
              </Parallax>
            </ParallaxProvider>
          </div>
        </div>

        <div className="col-lg-8 col-12 text-start color-dk-dark line-height-lg px-0 bg-color-w py-1">
          <div
            ref={refFact1}
            className={
              refFact1isVisible
                ? "fade-in-section is-visible row m-0 text-center py-2"
                : "fade-in-section row m-0 text-center py-2"
            }
          >
            <div className="row mx-0 justify-content-center">
              <ProductCard
                img={Rank1NMV}
                link="https://www.digikala.com/product/dkp-4958276/"
                title={"Xiaomi POCO X3 Pro | M2102J20SG 2Sim / 256GB / 8GB RAM"}
                rank={"1"}
              />
            </div>
            <div className="row mx-0 justify-content-center">
              <ProductCard
                img={Rank2NMV}
                link="https://www.digikala.com/product/dkp-3893718/"
                title={"Apple iPhone 12 Pro max | A2412 – 2Sim / 256GB"}
                rank={"2"}
              />
              <ProductCard
                img={Rank3NMV}
                link="https://www.digikala.com/product/dkp-3868296/"
                title={"Apple iPhone 12 | A2404 ZAA - 2Sim / 128GB"}
                rank={"3"}
              />
              <ProductCard
                img={Rank4NMV}
                link="https://www.digikala.com/product/dkp-4834144/"
                title={
                  "Samsung Galaxy A32 Phone | SMA325F/DS - 2Sim / 128GB / 6GB RAM"
                }
                rank={"4"}
              />
              <ProductCard
                img={Rank5NMV}
                link="https://www.digikala.com/product/dkp-4122136/"
                title={"Samsung galaxy A12 Phone | SMA125F/DS - 2Sim / 64GB"}
                rank={"5"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RowBestNMV;
